<template>
  <v-container>
    <v-layout justify-centerv-if="overlay">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="blue"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title style="font-size: 2em">{{ messaggio }}</v-card-title>
          <v-card-actions>
              <v-btn @click="$router.push('/')" >Torna al login</v-btn>
              </v-card-actions>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      overlay: false,
      messaggio: "",
      id: 0,
      hash: ""
    };
  },
  mounted() {
    this.overlay = true;
    this.id = this.$route.params.id;
    this.hash = this.$route.params.hash;
    this.AttivaUtente(this.id, this.hash);
  },
  methods: {
    AttivaUtente(id,hash){
      axios.get(this.$store.state.servicePath +"/api/Login/AttivaUtente/" + this.id + "/" + this.hash)
      .then(res=>{
        this.overlay = false;
        this.messaggio = res.data;
      })
      .catch(err=>{
        this.overlay = false;
        this.messaggio = "Si è verificato un problema con l'attivazione dell'utente.";
      })
    }

  }
  
};
</script>